import { render } from "./scrollPage.vue?vue&type=template&id=bd916d72"
import script from "./scrollPage.vue?vue&type=script&lang=js"
export * from "./scrollPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__